var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _path2, _path3, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearSearch24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5181 15.7584C18.1415 15.335 18.0959 14.7189 18.3365 14.2059C18.8537 13.1025 19.1429 11.8707 19.1429 10.5714C19.1429 5.83756 15.3053 2 10.5714 2C5.83756 2 2 5.83756 2 10.5714C2 15.3053 5.83756 19.1429 10.5714 19.1429C11.8707 19.1429 13.1025 18.8537 14.2059 18.3364C14.719 18.0959 15.3351 18.1415 15.7584 18.5181L18.7878 21.2122C19.4573 21.8816 20.5427 21.8816 21.2122 21.2122C21.8817 20.5427 21.8817 19.4573 21.2122 18.7878L18.5181 15.7584ZM16.5714 10.5714C16.5714 13.8851 13.8851 16.5714 10.5714 16.5714C7.25772 16.5714 4.57143 13.8851 4.57143 10.5714C4.57143 7.25772 7.25772 4.57143 10.5714 4.57143C13.8851 4.57143 16.5714 7.25772 16.5714 10.5714Z",
    fill: "#A65858"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6,
    cy: 10.6,
    r: 7.1,
    stroke: "url(#paint0_linear_1_391)",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.87256,
    cy: 17.9021,
    r: 1.77039,
    fill: "url(#paint1_linear_1_391)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3257,
    cy: 17.2761,
    r: 1.77039,
    fill: "url(#paint2_linear_1_391)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.12332,
    cy: 16.1317,
    r: 1.77039,
    fill: "url(#paint3_linear_1_391)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.89384,
    cy: 16.4584,
    r: 1.77039,
    fill: "url(#paint4_linear_1_391)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2249,
    cy: 15.5057,
    r: 1.77039,
    fill: "url(#paint5_linear_1_391)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.77042,
    cy: 14.3613,
    r: 1.77039,
    fill: "url(#paint6_linear_1_391)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7703,
    cy: 14.7704,
    r: 1.77039,
    fill: "url(#paint7_linear_1_391)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4168,
    cy: 5.72961,
    r: 1.77039,
    fill: "url(#paint8_linear_1_391)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5398,
    cy: 7.00891,
    r: 1.77039,
    fill: "url(#paint9_linear_1_391)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7703,
    cy: 12.7704,
    r: 1.77039,
    fill: "url(#paint10_linear_1_391)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.64286,
    cy: 17.4939,
    r: 1.77039,
    fill: "url(#paint11_linear_1_391)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2714,
    cy: 19.0465,
    r: 1.77039,
    fill: "url(#paint12_linear_1_391)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.52356,
    cy: 12.3201,
    r: 1.77039,
    fill: "url(#paint13_linear_1_391)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.96121,
    cy: 7.27979,
    r: 1.77039,
    fill: "url(#paint14_linear_1_391)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.96121,
    cy: 5.13257,
    r: 1.77039,
    fill: "url(#paint15_linear_1_391)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.13993,
    cy: 5.23853,
    r: 1.77039,
    fill: "url(#paint16_linear_1_391)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.06425,
    cy: 3.46814,
    r: 1.77039,
    fill: "url(#paint17_linear_1_391)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4346,
    cy: 3.95923,
    r: 1.77039,
    fill: "url(#paint18_linear_1_391)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7959,
    cy: 3.36218,
    r: 1.77039,
    fill: "url(#paint19_linear_1_391)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9754,
    cy: 4.64148,
    r: 1.77039,
    fill: "url(#paint20_linear_1_391)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4168,
    cy: 4.83203,
    r: 1.77039,
    fill: "url(#paint21_linear_1_391)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1931,
    cy: 11.3662,
    r: 1.77039,
    fill: "url(#paint22_linear_1_391)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.07166,
    cy: 10.8206,
    r: 1.77039,
    fill: "url(#paint23_linear_1_391)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5398,
    cy: 9.27039,
    r: 1.77039,
    fill: "url(#paint24_linear_1_391)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19095,
    cy: 8.7793,
    r: 1.77039,
    fill: "url(#paint25_linear_1_391)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6051,
    cy: 17.0062,
    r: 1.77039,
    fill: "url(#paint26_linear_1_391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.443C5 1.74479 5.69737 1.26151 6.35112 1.50667L8.35112 2.25667C8.74143 2.40304 9 2.77616 9 3.193V4.807C9 5.22384 8.74143 5.59696 8.35112 5.74333L6.35112 6.49333C5.69737 6.73849 5 6.25521 5 5.557V2.443Z",
    fill: "url(#paint27_linear_1_391)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.443C16 1.74479 15.3026 1.26151 14.6489 1.50667L12.6489 2.25667C12.2586 2.40304 12 2.77616 12 3.193V4.807C12 5.22384 12.2586 5.59696 12.6489 5.74333L14.6489 6.49333C15.3026 6.73849 16 6.25521 16 5.557V2.443Z",
    fill: "url(#paint28_linear_1_391)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 3,
    height: 4,
    rx: 1,
    fill: "url(#paint29_linear_1_391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_391",
    x1: 2,
    y1: 2,
    x2: 19.2,
    y2: 19.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_391",
    x1: 6.10217,
    y1: 16.1317,
    x2: 9.64294,
    y2: 19.6725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_391",
    x1: 12.5553,
    y1: 15.5057,
    x2: 16.0961,
    y2: 19.0465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_391",
    x1: 3.35294,
    y1: 14.3613,
    x2: 6.89371,
    y2: 17.9021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_391",
    x1: 5.12345,
    y1: 14.688,
    x2: 8.66422,
    y2: 18.2288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_391",
    x1: 13.4545,
    y1: 13.7354,
    x2: 16.9953,
    y2: 17.2761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_391",
    x1: 2.00003,
    y1: 12.5909,
    x2: 5.5408,
    y2: 16.1317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_391",
    x1: 14.9999,
    y1: 13,
    x2: 18.5407,
    y2: 16.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_391",
    x1: 13.6464,
    y1: 3.95923,
    x2: 17.1872,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_391",
    x1: 15.7694,
    y1: 5.23853,
    x2: 19.3102,
    y2: 8.7793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_391",
    x1: 14.9999,
    y1: 11,
    x2: 18.5407,
    y2: 14.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_391",
    x1: 7.87247,
    y1: 15.7235,
    x2: 11.4132,
    y2: 19.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_391",
    x1: 9.50098,
    y1: 17.2761,
    x2: 13.0418,
    y2: 20.8169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_391",
    x1: 2.75317,
    y1: 10.5497,
    x2: 6.29395,
    y2: 14.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_391",
    x1: 3.19083,
    y1: 5.5094,
    x2: 6.7316,
    y2: 9.05017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_391",
    x1: 3.19083,
    y1: 3.36218,
    x2: 6.7316,
    y2: 6.90295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_391",
    x1: 5.36954,
    y1: 3.46814,
    x2: 8.91032,
    y2: 7.00891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_391",
    x1: 6.29386,
    y1: 1.69775,
    x2: 9.83463,
    y2: 5.23853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_391",
    x1: 8.66422,
    y1: 2.18884,
    x2: 12.205,
    y2: 5.72961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_391",
    x1: 11.0255,
    y1: 1.5918,
    x2: 14.5663,
    y2: 5.13257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_391",
    x1: 12.205,
    y1: 2.87109,
    x2: 15.7458,
    y2: 6.41187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_391",
    x1: 13.6464,
    y1: 3.06165,
    x2: 17.1872,
    y2: 6.60242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_391",
    x1: 16.4228,
    y1: 9.59583,
    x2: 19.9635,
    y2: 13.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_391",
    x1: 1.30127,
    y1: 9.05017,
    x2: 4.84204,
    y2: 12.5909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_391",
    x1: 15.7694,
    y1: 7.5,
    x2: 19.3102,
    y2: 11.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_391",
    x1: 1.42056,
    y1: 7.00891,
    x2: 4.96133,
    y2: 10.5497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_391",
    x1: 9.83472,
    y1: 15.2358,
    x2: 13.3755,
    y2: 18.7766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_391",
    x1: 5,
    y1: 1,
    x2: 10.5385,
    y2: 4.69231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_391",
    x1: 16,
    y1: 1,
    x2: 10.4615,
    y2: 4.69231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_391",
    x1: 9,
    y1: 2,
    x2: 12.84,
    y2: 4.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearSearch24);
export default __webpack_public_path__ + "static/media/newyear-search_24.eaeb18b2.svg";
export { ForwardRef as ReactComponent };